import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { Box, Typography, useTheme } from '@mui/material';

interface RankIconProps {
  index: number;
}

export const RankIcon = ({ index }: RankIconProps) => {
  const theme = useTheme();
  const getRankColor = (i: number) => {
    if (i === 0) return theme.palette.rankColors.gold;
    if (i === 1) return theme.palette.rankColors.silver;
    if (i === 2) return theme.palette.rankColors.bronze;
    return undefined;
  };

  return (
    <Box
      sx={{
        display: 'flex',
      }}
    >
      {index < 3 && (
        <EmojiEventsIcon
          sx={{
            color: getRankColor(index),
            fontSize: '2.875rem',
            mb: 0.5,
          }}
        />
      )}
      <Typography
        variant="body1"
        sx={{
          fontWeight: 'bold',
          fontSize: index < 3 ? '2.25rem' : index < 5 ? '2.125rem' : '2rem',
          whiteSpace: 'nowrap',
          color: index < 5 ? theme.palette.text.primary : theme.palette.rankColors.gray,
        }}
      >
        {index + 1}位
      </Typography>
    </Box>
  );
};
